module.exports = __webpack_public_path__ + "static/Screen_inside_mob_02_on_landing-808e33e038745f8f61c2ef1e8668da5a.png";